import React from 'react';
import ReactDOM from 'react-dom/client';
// REDESIGN Stage 1: Inter, genuinely self-hosted via @fontsource (real .woff2 files bundled by
// the build, no CDN and no network dependency). Fixes the silent fallback the design review
// found: the codebase named 'Inter' in a fontFamily but never loaded it, so that screen quietly
// rendered in a different face from every other one. Only the weights the type scale actually
// uses are imported, to keep the bundle honest.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
import './i18n';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import { ToastProvider } from './ToastContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ToastProvider>
        <App />
      </ToastProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
